import { render, staticRenderFns } from "./Modelev2.vue?vue&type=template&id=1e1c0533&"
import script from "./Modelev2.vue?vue&type=script&lang=js&"
export * from "./Modelev2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports